module.exports = __webpack_public_path__ + "img/icon_ht_calendar.22179bb3.svg";